const AcademicDetails = () => {
    return (
        <div id="top" className="vision-card">

            <h3>ACADEMIC DETAILS</h3>

            <div className="table-section-wrap">
                <table className="table-section">
                    <thead>
                        <tr>
                            <th colSpan="2">
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "flex-start",
                                        flexWrap: "wrap",
                                        width: "100%",
                                    }}
                                >
                                    <span>School Infrastructure Details</span>

                                    <div style={{ textAlign: "right" }}>
                                        <div>55124-NAV JEEVAN MISSION SCH PO ASHISHNAGAR DEORIA UP</div>
                                        <div>Date: 15-12-2016</div>
                                    </div>
                                </div>
                            </th>
                        </tr>
                        <br />
                        <tr>
                            <th>SUBJECTS OFFERED FOR CLASS 10</th>
                            <th>SUBJECTS OFFERED FOR CLASS 12</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td>
                                002---HINDI COURSE-A <br />
                                184---ENGLISH LANGUAGE AND LITERATURE <br />
                                041---MATHEMATICS STANDARD<br />
                                241---MATHEMATICS BASIC <br />
                                086---SCIENCE <br />
                                087---SOCIAL SCIENCE <br />
                                417---ARTIFICAL INTELLIGENCE (AI)
                            </td>

                            <td>
                                301---ENGLISH CORE <br />
                                302---HINDI CORE <br />
                                041---MATHEMATICS <br />
                                044---BIOLOGY <br />
                                042---PHYSICS <br />
                                043---CHEMISTRY <br />
                                055---ACCOUNTANCY <br />
                                054---BUSINESS STUDIES <br />
                                030---ECONOMICS <br />
                                027---HISTORY <br />
                                028---POLITICAL SCIENCE <br />
                                048---PHYSICAL EDUCATION <br />
                                083---COMPUTER SCIENCE <br />
                                037---PSYCHOLOGY <br />

                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AcademicDetails;